import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "file-select ma-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("div", {
        class: "select-button",
        onDragover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dragover && _ctx.dragover(...args))),
        onDragleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dragleave && _ctx.dragleave(...args))),
        onDrop: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)))
      }, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(!_ctx.fileName ? _ctx.label : ''), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, "Select File")),
        (_ctx.fileName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "File selected: " + _toDisplayString(_ctx.fileName), 1))
          : _createCommentVNode("", true)
      ], 32),
      _createElementVNode("input", {
        ref: "file",
        type: "file",
        accept: ".zip",
        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
      }, null, 544)
    ]),
    _withDirectives(_createElementVNode("input", {
      class: _normalizeClass(["url-input", {
      'url-invalid': !_ctx.parsedURL && _ctx.url != '',
      'url-valid': _ctx.parsedURL || _ctx.url == ''
    }]),
      ref: "url_input",
      type: "url",
      placeholder: "type a URL",
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.url) = $event)),
      onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.urlKeyup && _ctx.urlKeyup(...args)))
    }, null, 34), [
      [_vModelText, _ctx.url]
    ])
  ], 64))
}